import { MARKUSPAID_SUCCESS, MARKUSPAID_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const markUsPaidReducer = (state = initialState, action) => {
    switch (action.type) {
        case MARKUSPAID_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case MARKUSPAID_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default markUsPaidReducer;
